import { Injectable } from '@angular/core'
import { LanguageCode } from '../_models/enum/language-code'
import { TranslocoService } from '@jsverse/transloco'
import { CacheService } from './cache.service'

@Injectable({
  providedIn: 'root',
})
export class RegionService {
  private defaultLanguage: LanguageCode = LanguageCode.English

  private clientLanguage: LanguageCode

  constructor(
    private translocoService: TranslocoService,
    private cache: CacheService
  ) {
    this.clientLanguage = this.defaultLanguage
  }

  async init(): Promise<void> {
    await this.setClientLanguage()
  }

  async setClientLanguage(language?: LanguageCode): Promise<void> {
    if (!language) {
      const preferredLanguage = localStorage.getItem('preferredLanguage')

      if (preferredLanguage) {
        this.clientLanguage = preferredLanguage as LanguageCode
      } else {
        const browserLanguage = window.navigator.language
        switch (browserLanguage) {
          case LanguageCode.Swedish:
            this.clientLanguage = LanguageCode.Swedish
            break
          case LanguageCode.English:
            this.clientLanguage = LanguageCode.English
            break
          case LanguageCode.Danish:
            this.clientLanguage = LanguageCode.Danish
            break
          case LanguageCode.Norwegian:
            this.clientLanguage = LanguageCode.Norwegian
            break
          case LanguageCode.German:
            this.clientLanguage = LanguageCode.German
            break
          default:
            this.clientLanguage = LanguageCode.English
            break
        }
      }
    } else {
      this.clientLanguage = language
    }
    this.translocoService.setActiveLang(this.clientLanguage.substring(0, 5))
    const user = await this.cache.getActiveUser()

    if (!user) {
      return
    }
    localStorage.setItem(
      'preferredLanguage',
      `${this.clientLanguage}_${user.id}`
    )
  }

  getClientLanguage(): LanguageCode {
    this.clientLanguage = this.translocoService.getActiveLang() as LanguageCode
    return this.clientLanguage
  }
}
